import React, { useEffect, Children } from 'react';
import { MapPin, Phone } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { motion, useAnimation } from 'framer-motion';
import { useInView } from 'react-intersection-observer';
export function ServiceArea() {
  const {
    t
  } = useLanguage();
  const controls = useAnimation();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  useEffect(() => {
    if (inView) {
      controls.start('visible');
    }
  }, [controls, inView]);
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.05
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      scale: 0.9
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.3
      }
    }
  };
  return <section id="areas" className="py-20 bg-white border-y border-gray-100" data-id="element-162">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-163">
        <div className="inline-flex items-center justify-center p-3 bg-red-50 rounded-full mb-6" data-id="element-164">
          <MapPin className="w-8 h-8 text-brand-red" data-id="element-165" />
        </div>

        <h2 className="text-3xl md:text-4xl font-heading font-extrabold text-brand-black mb-10" data-id="element-166">
          {t.serviceArea.title}
        </h2>

        <motion.div ref={ref} variants={containerVariants} initial="hidden" animate={controls} className="flex flex-wrap justify-center gap-3 md:gap-4" data-id="element-167">
          {t.serviceArea.cities.map((city, index) => <motion.span key={index} variants={itemVariants} className="px-4 py-2 bg-gray-50 border border-gray-200 rounded-full text-brand-black font-medium text-sm md:text-base hover:border-brand-blue hover:bg-blue-50 transition-colors cursor-default" data-id="element-168">
              {city}
            </motion.span>)}
        </motion.div>

        <div className="mt-12" data-id="element-169">
          <a href="tel:8324397965" className="inline-flex items-center justify-center gap-2 bg-brand-blue text-white px-8 py-4 rounded-md font-bold text-lg hover:bg-blue-900 transition-all shadow-lg hover:-translate-y-0.5 min-h-[56px]" data-id="element-170">
            <Phone className="w-5 h-5" data-id="element-171" />
            (832) 439-7965
          </a>
        </div>
      </div>
    </section>;
}